'use client'

import Link from 'next/link'
import { useTranslation } from 'react-i18next'

export function LandingFooter() {
  const { t } = useTranslation()

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <footer className="border-t border-border/50 bg-gradient-to-b from-background to-green-50/20 dark:to-green-950/10">
      <div className="container px-4 py-12 max-w-7xl mx-auto">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {/* Left Column - Logo & Description */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <img 
                src="/logo%20banquieto.png" 
                alt="Banquieto" 
                className="h-9 w-auto"
                width={120}
                height={36}
                loading="lazy"
              />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Kompleksowy system CRM dla sal weselnych i restauracji. Kalendarz rezerwacji, zarządzanie klientami, menu, płatności i dokumenty.
            </p>
          </div>
          
          {/* Middle & Right Columns - Links & Contact */}
          <div className="lg:col-span-2">
            <div className="grid grid-cols-2 gap-6 md:gap-8">
              <div>
                <h2 className="text-sm font-semibold mb-3">Usługi</h2>
                <ul className="space-y-2 text-sm">
                  <li>
                    <button
                      onClick={() => scrollToSection('features')}
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {t('landing.footer.features')}
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => scrollToSection('pricing')}
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {t('landing.footer.pricing')}
                    </button>
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="text-sm font-semibold mb-3">Firma</h2>
                <ul className="space-y-2 text-sm">
                  <li>
                    <button
                      onClick={() => scrollToSection('consultation')}
                      className="text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {t('landing.footer.contact')}
                    </button>
                  </li>
                  <li>
                    <Link
                      href="#"
                      className="text-muted-foreground hover:text-foreground transition-colors"
                      aria-label={t('landing.footer.privacy')}
                    >
                      {t('landing.footer.privacy')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-border/50 text-center space-y-1.5">
          <p className="text-sm text-muted-foreground">
            {t('landing.footer.copyright')}
          </p>
          <p className="text-xs text-muted-foreground/80">
            {t('landing.footer.builtBy')}{' '}
            <Link 
              href="https://houseofbytes.pl" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-green-600 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300 transition-colors underline"
            >
              House of Bytes
            </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}

